import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import KeepUrlFragment from './KeepUrlFragment';

const mapStateToProps = (state: any) => ({
  settings: state.trackerSettings.global.settings,
  isLoading: state.trackerSettings.global.isLoading,
  failed: state.trackerSettings.global.failed,
});

export const ConnectedKeepUrlFragment = connect(
  mapStateToProps, null,
)(KeepUrlFragment);

export default withTranslation(['administration'])(ConnectedKeepUrlFragment as any);
